import React from 'react';
import { withRouter } from 'inferno-router';
import {
  Image,
  StyleSheet,
  Text,
  TouchableHighlight,
  View,
} from './base_components';

import UserCurrencyStore from '../stores/user_currency_store';
import util from '../tools/util';

const styles = StyleSheet.create({
  dankCoinDisplay: {
    height: '3em',
    //width: '10em',
    borderWidth: '0.3em',
    borderColor: '#00b59b',
    backgroundColor: '#82d3ce',
    borderRadius: '0.3em',
  },
  highlight: {
    flex: 1,
    alignSelf: 'stretch',
  },
  inner: {
    flex: 1,
    alignSelf: 'stretch',
    paddingLeft: '1em',
    paddingRight: '1em',

    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  text: {
    marginTop: '0.7em',
    marginLeft: '1em',
    color: 'white',
    fontSize: '1.4em',
  },
  image: {
    width: '2em',
    height: '2em',
  },
});

const COIN_IMG = require('../assets/img/dank_coin.png');

class DankCoinDisplay extends React.PureComponent {
  state = {
    dank_coin_balance: UserCurrencyStore.getBalance('dank_coin') || 0,
  };
  componentDidMount() {
    UserCurrencyStore.addChangeListener(this._onCurrencyUpdate);
    UserCurrencyStore.fetchCurrency('dank_coin');
    this._onCurrencyUpdate();
  }
  componentWillUnmount() {
    UserCurrencyStore.addChangeListener(this._onCurrencyUpdate);
  }
  _onCurrencyUpdate = () => {
    const dank_coin_balance = UserCurrencyStore.getBalance('dank_coin') || 0;
    this.setState({ dank_coin_balance });
  };
  _onPress = () => {
    this.props.history.push('/dankcoin');
  };

  render() {
    const { style } = this.props;
    const { dank_coin_balance } = this.state;

    return (
      <View style={[styles.dankCoinDisplay, style]}>
        <TouchableHighlight
          style={styles.highlight}
          underlayColor='rgba(0,0,0,0.3)'
          onPress={this._onPress}
        >
          <View style={styles.inner}>
            <Image style={styles.image} source={COIN_IMG} />
            <Text style={styles.text}>
              {util.doubleToString(dank_coin_balance)}
            </Text>
          </View>
        </TouchableHighlight>
      </View>
    );
  }
}
export default withRouter(DankCoinDisplay);
